import React from 'react';
import { Modal, Button, CheckPicker } from 'rsuite';
import ExistingSchedulesDisplay from './ExistingSchedulesDisplay';
import ScheduleTypeForm from './ScheduleTypeForm';

const AddScheduleModal = ({ 
    open,
    onClose,
    selectedDate,
    selectedDates = [],
    users,
    selectedUsers,
    onSelectedUsersChange,
    selectedSchedules,
    scheduleTypes,
    onAddScheduleType,
    onRemoveScheduleType,
    onUpdateScheduleType,
    onConfirm,
    loading,
    existingSchedules,
    getColorForType,
    formatDate,
    errorMessage,
    canManage = false,
    onRemoveExistingSchedule
}) => {
    const handleClose = () => {
        onClose();
    };

    return (
        <Modal open={open} onClose={handleClose} size="lg">
            <Modal.Header>
                <Modal.Title>
                    {selectedDates.length > 0 
                        ? `批次新增班表 - ${selectedDates.length} 個日期`
                        : `新增班表 - ${selectedDate && formatDate(selectedDate)}`
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage && (
                    <div style={{
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        padding: '12px 16px',
                        borderRadius: '4px',
                        border: '1px solid #f5c6cb',
                        marginBottom: '20px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}>
                        <strong>錯誤：</strong> {errorMessage}
                    </div>
                )}
                
                {selectedDates.length > 0 && (
                    <div style={{
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                        padding: '12px 16px',
                        borderRadius: '4px',
                        border: '1px solid #bbdefb',
                        marginBottom: '20px',
                        fontSize: '14px'
                    }}>
                        <strong>選取的日期：</strong> {selectedDates.join(', ')}
                    </div>
                )}
                
                {selectedDates.length === 0 && (
                    <ExistingSchedulesDisplay 
                        existingSchedules={existingSchedules}
                        getColorForType={getColorForType}
                        canManage={canManage}
                        onRemoveSchedule={onRemoveExistingSchedule}
                    />
                )}
                
                <div style={{ marginBottom: 20 }}>
                    <label>選擇員工：</label>
                    <CheckPicker
                        data={users.map(user => ({ label: user.name, value: user.uuid }))}
                        value={selectedUsers}
                        onChange={(value) => {
                            onSelectedUsersChange(value || []);
                        }}
                        placeholder="選擇員工"
                        cleanable={false}
                        countable={false}
                        block
                        style={{ width: '100%' }}
                    />
                </div>
                
                <ScheduleTypeForm
                    selectedSchedules={selectedSchedules}
                    scheduleTypes={scheduleTypes}
                    onAddScheduleType={onAddScheduleType}
                    onRemoveScheduleType={onRemoveScheduleType}
                    onUpdateScheduleType={onUpdateScheduleType}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    onClick={onConfirm} 
                    appearance="primary" 
                    disabled={loading || !!errorMessage}
                >
                    {loading ? '處理中...' : (selectedDates.length > 0 ? '確認批次新增' : '確認新增')}
                </Button>
                <Button onClick={handleClose} appearance="subtle">
                    取消
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddScheduleModal;
